import React from 'react';
import { WebUrlData } from '@base-configs';
import { Navigate } from 'react-router-dom';

export function ConfigurationFeature() {
  return <Navigate to={WebUrlData.configuration_email_template} replace />;
}
